import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalAuthComponent } from './modal-auth/modal-auth.component';
import { HeaderModalComponent } from './header-modal/header-modal.component';
import { CodeInputModule } from 'angular-code-input';
import { ModalComponent } from '../modal/modal.component';
import { ContentTwoModalDesktopComponent } from './content-two-modal-desktop/content-two-modal-desktop.component';
import { ContentTwoModalMobileComponent } from './content-two-modal-mobile/content-two-modal-mobile.component';
import { MetodhAuthComponent } from './metodh-auth/metodh-auth.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '../components.module';
import { LoadingModule } from '../loading/loading.module';

@NgModule({
  declarations: [
    ModalAuthComponent,
    HeaderModalComponent,
    ModalComponent,
    ContentTwoModalDesktopComponent,
    ContentTwoModalMobileComponent,
    MetodhAuthComponent,
  ],
  imports: [
    CommonModule,
    CodeInputModule,
    ReactiveFormsModule,
    FormsModule,
    LoadingModule,
  ],
  exports: [
    ModalAuthComponent,
    HeaderModalComponent,
    ModalComponent,
    ContentTwoModalDesktopComponent,
    ContentTwoModalMobileComponent,
    MetodhAuthComponent,
  ],
})
export class ModalAuthModule {}
